import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { HttpRepositoryResponse } from '../core/http-repository-response';
import { map, catchError } from 'rxjs/operators';
import { AFToken } from '../core/af-token';

@Injectable({
  providedIn: 'root'
})

export class AntiForgeryTokenService {
  constructor(private http: HttpClient, @Inject('BASE_URL') private readonly baseUrl: string) { }
  private readonly tokenUri: string = 'Home/AFToken';

  public getAFToken(): Observable<HttpRepositoryResponse<AFToken>> {
    return this.http.get<AFToken>(this.baseUrl + this.tokenUri).pipe(
      map(x => new HttpRepositoryResponse<AFToken>(x)),
      catchError((err: HttpErrorResponse) => this._catchError<AFToken>(err)));
  }

  private _catchError<AFToken>(error: HttpErrorResponse): Observable<HttpRepositoryResponse<AFToken>> {
    var resp = new HttpRepositoryResponse<AFToken>(null);
    resp.hasErrors = true;
    resp.error = 'Ops! Some error had occurred. Please refresh the page.';
    resp.statusCode = error.status;

    if (resp.statusCode == 401) {
      window.open('/', '_self');
    }

    return of(resp);
  }
}
